
import {
  CREATING_SESSION,
  CREATE_SESSION_INVALID_PASSWORD,
  CREATE_SESSION_INVALID_EMAIL,
  CREATE_SESSION_ERROR,
  CREATED_SESSION
} from 'actions'

const initialState = {
  error: null,
  wrongEmail: false,
  wrongPassword: false,
  email: null,
  password: null,
  isRequesting: false,
  didCreate: false
}

export default function session (state = initialState, { type, payload }) {
  switch (type) {
    case CREATING_SESSION:
      return {
        ...state,
        isRequesting: true,
        email: payload.email,
        password: payload.password
      }
    case CREATE_SESSION_INVALID_PASSWORD:
      return {
        ...state,
        isRequesting: false,
        wrongEmail: false,
        wrongPassword: true
      }
    case CREATE_SESSION_INVALID_EMAIL:
      return {
        ...state,
        isRequesting: false,
        wrongEmail: true,
        wrongPassword: false
      }
    case CREATE_SESSION_ERROR:
      return {
        ...state,
        wrongEmail: false,
        wrongPassword: false,
        error: payload.error
      }
    case CREATED_SESSION:
      return {
        isRequesting: false,
        didCreate: true
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/session.js